import { API_BASE_URL } from '@synergy/config';
import { createAction } from '@reduxjs/toolkit';

import { AppDispatch, AppState } from '../../store/store';
import {
    ItemPriceChangeResponse,
    SupplierPriceChangeResponse,
} from '../api/models/shopping-cart-price-change-response';
import { PoolSnackbar } from '../components/snackbars/pool-snackbar';
import { ShoppingCartItemApi } from '../api/shopping-cart-item-api';
import { ShoppingCartMinimal } from '../models/shopping-cart-minimal';
import { enqueueSnackbar } from './snackbar-actions';

const shoppingCartItemApi = new ShoppingCartItemApi(API_BASE_URL);

export const shoppingCartItemQuantityChanged = createAction<{
    itemId: number;
    quantity: number;
    priceChange: ItemPriceChangeResponse;
}>('shoppingCart/item-quantity-changed');

export const shoppingCartItemRemoved = createAction<{
    itemId: number;
    priceChange: SupplierPriceChangeResponse;
}>('shoppingCart/item-removed');
export const shoppingCartItemAdded = createAction<ShoppingCartMinimal>('shoppingCart/item-added');

export const addArticleToCart = (articleId: number, quantity: number) => async (dispatch: AppDispatch) => {
    const response = await shoppingCartItemApi.addToCart(articleId, quantity);
    if (response.success) {
        dispatch(enqueueSnackbar(PoolSnackbar.success('app.article.shoppingCart.added')));
        dispatch(shoppingCartItemAdded(response.result));
    } else {
        dispatch(enqueueSnackbar(PoolSnackbar.fatal()));
    }
};

export const setArticleQuantity =
    (itemId: number, quantity: number) => async (dispatch: AppDispatch, _getState: () => AppState) => {
        const response = await shoppingCartItemApi.changeQuantity(itemId, quantity);
        if (response.success) {
            dispatch(shoppingCartItemQuantityChanged({ itemId, quantity, priceChange: response.result }));
        } else {
            dispatch(enqueueSnackbar(PoolSnackbar.fatal()));
        }
    };

export const removeArticleFromCart = (itemId: number) => async (dispatch: AppDispatch) => {
    const response = await shoppingCartItemApi.removeFromCart(itemId);
    if (response.success) {
        dispatch(shoppingCartItemRemoved({ itemId, priceChange: response.result }));
    } else {
        dispatch(enqueueSnackbar(PoolSnackbar.fatal()));
    }
};
